import React, {useEffect, useRef } from 'react';
import getColor from '../utils/interpolateColor';

const TotalScoreGeneral = ({ score, size = 'default' }) => {
   
    const logoRef = useRef(null);
    // Size configurations with proportional scaling
    const sizeConfig = {
        xxs: { scale: 0.5, width: 66, height: 24, fontSize: 0.62, logoSize: 14, padding: '2px 4px', borderWidth: 1 },
        xs: { scale: 0.6, width: 84, height: 29, fontSize: 0.72, logoSize: 17, padding: '3px 6px', borderWidth: 1.2 },
        small: { scale: 0.75, width: 105, height: 36, fontSize: 0.9, logoSize: 21, padding: '4px 8px', borderWidth: 1.5 },
        default: { scale: 1, width: 140, height: 48, fontSize: 1.2, logoSize: 28, padding: '5px 10px', borderWidth: 2 },
        large: { scale: 1.25, width: 175, height: 60, fontSize: 1.5, logoSize: 35, padding: '6px 13px', borderWidth: 2.5 },
        xl: { scale: 1.5, width: 210, height: 72, fontSize: 1.8, logoSize: 42, padding: '8px 15px', borderWidth: 3 }
    };

    const config = sizeConfig[size] || sizeConfig.default;


    useEffect(() => {
        if (logoRef.current && score !== null) {
            const color = getColor(score);
            logoRef.current.style.borderColor = color;
        }
    }, [score]);

    const buttonStyle = {
        width: `${config.width}px`,
        maxHeight: `${config.height}px`,
        fontSize: `${config.fontSize}rem`,
        padding: config.padding,
        borderWidth: `${config.borderWidth}px`,
        borderRadius: '30px',
        color: '#6b7280'
    };

    const logoContainerStyle = {
        width: `${config.logoSize}px`,
        height: `${config.logoSize}px`,
        borderWidth: `${config.borderWidth}px`,
        marginRight: `${Math.round(5 * config.scale)}px`
    };

    return (
        <button 
            className="total-scale-button" 
            style={buttonStyle}
            data-score={String(score || 0)} 
            data-toggle="tooltip" 
            data-placement="bottom" 
            aria-hidden="true" 
            title="Totalpoängen utgör medelvärdet av produktens poäng för miljö, hälsa och rättvisa."
        >
            <span 
                ref={logoRef}
                className="total-logo-container"
                style={logoContainerStyle}
            >
                <img className="total-logo" src="/assets/images/consupedia.png" alt="Consupedia Logo" />
            </span>
            <span>{score || 0} / 100</span>
        </button>
    );
};

export default TotalScoreGeneral;
